import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
import LfRadioGroupComponent from '@/components/forms/fields/LfRadioGroupComponent.vue'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import { computed, onBeforeUnmount} from 'vue'
import { useI18n } from 'vue-i18n-composable'
import useStageSelector from './composable/useStageSelector'
import { Stage } from './types/StageSelectorTypes'
import { Icons } from '@/icons/icons'
import { TranslateResult } from 'vue-i18n'
import useCompany from '@/composables/useCompany'


export default /*#__PURE__*/_defineComponent({
  __name: 'StageSelectorComponent',
  setup(__props) {

const { t } = useI18n()

const texts = {
  currentStage: t('components.stage_selector.current_stage'),
  filterStages: t('components.stage_selector.filter_stages'),
  selectAll: t('components.stage_selector.select_all').toString()
}

const allStageItem:Stage = {
  current: 0,
  ended: 0,
  id: '0',
  notes: '',
  stage: texts.selectAll
}

// COMPOSABLES   ======================================================================================================
const { stages, setSelectedStage, selectedStage, expedientHasStages, resetStages, currentStageId } = useStageSelector()
const { defaultStage } = useCompany()

// COMPUTEDS ==========================================================================================================
const selectedStageId = computed<string>(() => defaultStage.value ? currentStageId.value : allStageItem.id)

const finalItems = computed<Stage[]>(() => [allStageItem, ...stages.value])

const isInitialStage = computed<boolean>(() => selectedStage.value === allStageItem.id || selectedStage.value === '')

const title = computed<TranslateResult | undefined>(() => {
  const defaultTitle = texts.filterStages
  const selectedStageTitle = finalItems.value.find((item) => String(item.id) === selectedStage.value)?.stage
  return isInitialStage.value ? defaultTitle : selectedStageTitle
})

const renderedIcon = computed<string>(() => (isInitialStage.value ? Icons.FILTER : Icons.FILTER_APPLIED))

// EVENTS =============================================================================================================
const setState = (stageId: string = allStageItem.id) => {
  setSelectedStage(stageId)
}

// HOOKS =============================================================================================================
onBeforeUnmount(() => {
  resetStages()
})

// WATCH
watch(currentStageId, () => {
  if (defaultStage.value) {
    setSelectedStage(currentStageId.value)
  }
})

return { __sfc: true,t, texts, allStageItem, stages, setSelectedStage, selectedStage, expedientHasStages, resetStages, currentStageId, defaultStage, selectedStageId, finalItems, isInitialStage, title, renderedIcon, setState, LfRadioGroupComponent, LexonTooltipComponent }
}

})